import {Col, ColType, Crud} from "../../comp/crud";
import {ApiClient} from "../../api/ApiClient";
import '../clientConfig/index.scss'
import {TextCell} from "../../comp/cell";
import {
    formatDate,
} from "../../utils";

let cols: Col[] = [
    {
        name: "客户端",
        key: "platform",
        hideInEdit: true,
        showInFilter: true,
        type: ColType.STRING
    },
    {
        name: "姓名",
        key: "userName",
        hideInEdit: true,
        showInFilter: true,
        type: ColType.STRING
    },
    {
        name: "城市",
        key: "city",
        hideInEdit: true,
        showInFilter: false,
        type: ColType.STRING
    },
    {
        name: "角色",
        key: "roleName",
        hideInEdit: true,
        showInFilter: false,
        type: ColType.STRING
    },
    {
        name: "手机号",
        key: "mobile",
        hideInEdit: true,
        showInFilter: true,
        type: ColType.STRING
    },
    {
        name: "登录IP",
        key: "userIp",
        hideInEdit: true,
        type: ColType.STRING
    },
    {
        name: "登录时间",
        key: "createdAt",
        showInFilter: true,
        type: ColType.DATE_RANGE,
    },
    {
        name: "登录结果",
        key: "resultDesc",
        showInFilter: true,
        type: ColType.STRING,
        render: a => <TextCell width={300} text={a} />
    },

    {
        name: "浏览器",
        key: "userAgent",
        showInFilter: true,
        type: ColType.STRING,
        render: a => <TextCell width={500} text={a} />
    },
    
]
export default function LoginLog(){
    let nowDate = new Date();       
        const initFilterValues = {
            createdAt: [nowDate, nowDate],
            platform: "web",
        };

        let startDateStr = formatDate(nowDate);
        let endDateStr = formatDate(nowDate);
        const initParams = {
            createdAt: startDateStr + "," + endDateStr,
            platform: "web",
        };
    
    return <Crud
        canUpdate={false}
        canCreate={false}
        name="登录日志"
        entityKey="loginLogs"
        initFilterValues={initFilterValues}
        initParams={initParams}
        pageSize={50}
        cols={cols}
    />
}